//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { intlFormat } from 'date-fns'

export default {
  props: {
    posts: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      categories: [
        '',
        this.$i18n.t('blog.category-1') || 'Company News',
        this.$i18n.t('blog.category-2') || 'Industry News',
        this.$i18n.t('blog.category-3') || 'Product News',
        this.$i18n.t('blog.category-4') || 'Events'
      ],
      slide: 0,
      nextInterval: 5000,
      interval: null,
      currentPost: 0,
      nextPost: 1,
      hideImg: false,
      animated: false,
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : null,
      isLargeScreen: typeof window !== 'undefined' ? window.matchMedia('(min-width: 1024px)').matches : false,
      first: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    changePost (next) {
      this.$refs.postSlider.setSlide(next)
    },
    getDate (postDate) {
      try {
        return intlFormat(new Date(postDate), {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
      } catch (err) {
        console.log(err)
        if (typeof postDate === 'string') {
          return postDate.substring(0, 10)
        }
        return ''
      }
    },
    onResize () {
      clearTimeout(this.interval)
      this.interval = setTimeout(() => {
        this.windowWidth = window.innerWidth
        this.isLargeScreen = window.matchMedia('(min-width: 1024px)').matches
      }, 500)
    }
  }
}
